'use client';

import { useState } from 'react';
import { Button } from '@spikemark/ui/components/design-system/button';
import { PricingCardButtonProps } from './types';
import { tracker } from '@spikemark/onboarding/tracking/tracker';
import { TRACKED_EVENTS } from '@spikemark/onboarding/tracking/events';
import { cn } from '@spikemark/ui/utils/cn';
export const PricingCardButton = ({
  title,
  highlight,
  className,
  variant = 'default',
  handleClick,
  children
}: PricingCardButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const buttonVariant = highlight ? 'primary' : variant;
  return <Button className={cn('justify-center', className)} variant={buttonVariant} onClick={() => {
    setIsLoading(true);
    tracker.track(TRACKED_EVENTS.actions.plan_select, {
      plan: title
    });
    handleClick?.();
  }} disabled={isLoading} loading={isLoading} data-sentry-element="Button" data-sentry-component="PricingCardButton" data-sentry-source-file="pricing-card-button.tsx">
      {children ? children : `Choose ${title}`}
    </Button>;
};